/* eslint-disable */
// <auto-generated>
// Generated by projects/template-ui/scripts/generate-contract-types.ts.
// Source: api/src/Riley.Jms.Application/Schemas/schema-manifest.json.
// </auto-generated>

export interface WorkflowReviewRecordRequest {
  decisionRecordId: number;
  expectedETag: string;
  notes?: string | null;
  notesLookupRevision?: string | null;
  occurrenceId: number;
  outcome: "approved" | "changes_required";
}

export const WorkflowReviewRecordRequestForm = {
  "contract": "WorkflowReviewRecordRequest",
  "version": 1,
  "fields": [
    {
      "name": "outcome",
      "type": "string",
      "control": "select",
      "label": "Review outcome",
      "labelToken": "workflow.review.outcome",
      "required": true,
      "nullable": false,
      "lookupDomain": "workflow.review.outcome",
      "options": [
        {
          "value": "approved",
          "label": "Approved",
          "labelToken": "workflow.review.outcome.approved"
        },
        {
          "value": "changes_required",
          "label": "Changes required",
          "labelToken": "workflow.review.outcome.changes_required"
        }
      ],
      "errorCodes": [
        "workflow.review.outcome_invalid"
      ],
      "supportsLayout": true
    },
    {
      "name": "notes",
      "type": "string",
      "control": "textarea",
      "label": "Review notes",
      "labelToken": "workflow.review.notes",
      "required": false,
      "nullable": true,
      "maxLength": 4000,
      "requiredWhen": {
        "field": "outcome",
        "equals": "changes_required"
      },
      "errorCodes": [
        "workflow.review.reason_required"
      ],
      "supportsLayout": true,
      "supportsLookup": true
    }
  ]
} as const;
